import { EventBus } from './event-bus.js'
import { UserManager, Log } from 'oidc-client'

class ApplicationUserManager extends UserManager {
	constructor() {
		var domain = window.location.host
		var protocol = window.location.protocol
		Log.logger.error = (err) => {
			if(err !== 'Frame window timed out'){
				// When user is logged already available the call gets cancelled which triggers an "Frame window timed out" error which should be ignored
				let error = err instanceof Error ? err : new Error(err)

				EventBus.$emit('error', error)
			}
		}

		super({
			authority: process.env.VUE_APP_AUTHORITY,
			client_id: 'pgz_scanner',
			redirect_uri: protocol + '//' + domain + '/#/callback/#',
			response_type: 'token id_token',
			scope: process.env.VUE_APP_SCOPE,
			post_logout_redirect_uri: protocol + '//' + domain + '/'
		})
	}

	async login() {
		if (process.env.VUE_APP_ENABLE_LOGIN === 'true') {
			try{
				await this.signinRedirect()
				return this.getUser()
			} catch (err){
				EventBus.$emit('error', err)
			}
		} else {
			if(window.navigator.onLine){
				return {
					id_token: 'test',
					session_state: 'test',
					access_token: 'test',
					refresh_token: undefined,
					token_type: 'Bearer',
					scope: 'openid profile pgz_gateway.test',
					profile: {
						s_hash: 'qQfIlPnWyza68ksXNK-FaQ',
						sid: 'VoG6ilJXY72k-_Dy-wczaw',
						sub: '0008da2b-0000-0000-0000-000000000000',
						auth_time: 1584608329,
						idp: 'local',
						amr: ['pwd'],

						// Tenants
						tenant: 'pgz-b2b-nl',
						// tenant: 'pgz-b2b',

						// Salesman
						// name:'Test salesman',
						// email:'test@test.com',

						// Retailer
						name: 'Test retailer',
						email: '114498@pgzinternational.com',

						// Customer group
						group: '990bab1f-ce1f-46c0-b144-9675c7db6ec0', // OHC Orkla
						// group: 'some-random-other-id'
						// group: ''
					}
				}
			} else {
				try{
					throw new Error('Offline')
				} catch (err) {
					EventBus.$emit('error', err)
				}
			}
		}
	}

	async logout() {
		return this.signoutRedirect()
	}
}

const applicationUserManager = new ApplicationUserManager()
export { applicationUserManager }
